<template>
  <div id="mine-collect">
    <div class="header">
      <!--   搜索   -->
      <div class="search-bar">
        <div class="search-box">
          <van-icon class="search-icon iconfont" class-prefix="icon" name="sousuo"></van-icon>
          <input type="search" v-model="params.search" placeholder="请输入服务名称" @keydown="searchHandle"/>
        </div>
        <p class="assistant" @click="searchHandle">搜索</p>
      </div>
      <van-tabs class="toggle-use-type" @click="toggleUseType" :title-active-color="mainColor" :color="mainColor">
        <van-tab title="全部服务" name=""/>
        <van-tab title="移动服务" name="2"/>
      </van-tabs>
    </div>
    <div class="box" v-if="!emptyShow">
      <ServiceItemLandscape v-for="(item,index) in data" :key="index" :service="item" :class="{'blur':item.useType.indexOf('2')===-1}"/>
    </div>
    <div class="empty-container" v-else>
      <Error type="empty"/>
    </div>
  </div>
</template>

<script>
import {getThemeParams} from "@/utils/theme";
import {queryMineCollect} from "@/api/mine";

export default {
  components: {
    ServiceItemLandscape: () => import("@/components/ServiceHall/ServiceItemLandscape"),
  },
  data() {
    return {
      params: {
        search: undefined,
        useType:undefined
      },
      emptyShow: false,
      data:[]
    }
  },
  computed:{
    mainColor() {
      if (getThemeParams('main_color')){
        return getThemeParams('main_color');
      } else {
        return '#003c88'
      }
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData(){
      queryMineCollect(this.params).then(resp=>{
        if(resp.code && resp.code != 200){
          Toast(resp.message)
          return
        }
        this.data = [];
        resp.data.forEach(item => {
          this.data.push(item);
        })
        if (this.data.length > 0) {
          this.emptyShow = false;
        } else {
          this.emptyShow = true;
        }
      })
    },
    searchHandle(e) {
      if (e.keyCode && e.keyCode != 13) {
        return
      } else {
        this.getData();
      }
    },
    toggleUseType(name){
      this.data = [];
      this.params.useType = undefined;
      if(name != ''){
        this.params.useType = name;
      }
      this.getData();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/theme/theme.scss";
#mine-collect{
  padding-top: 101px;
}
.header {
  height: 86px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  .search-bar {
    width: 100%;
    height: 44px;
    padding: 8px 15px;
    box-sizing: border-box;
    display: -webkit-flex;/* Safari */
    display: flex;
    background: #fff;
    color: $c333;
    .search-box {
      height: 28px;
      line-height: 28px;
      padding: 0 15px 0 35px;
      background: #F7F7F7;
      border: 1px solid #FFFFFF;
      border-radius: 14px;
      flex: 1;
      position: relative;
      @extend .font13;
      .search-icon{
        position: absolute;
        top:0;
        left: 15px;
      }
      input {
        float: left;
        width: 100%;
        height: 28px;
        line-height: 28px;
        background: transparent;
        @extend .font13;
        &::-webkit-search-cancel-button{
          -webkit-appearance: none;
        }
      }
    }
    .assistant{
      height: 28px;
      line-height: 28px;
      margin-left: 15px;
      @extend .font16;
    }
  }
}
.box{
  padding:0 15px;
}
.empty{
  margin-top: 100px;
}
</style>
